/**
 * Cloud BE error codes that must NOT auto-dismiss in the UI.
 *
 * Reason: user has limited time to read critical errors (quota, capacity,
 * data integrity). These represent unrecoverable states the user must
 * actively acknowledge and react to.
 *
 * Pattern mirrors W6 PR #38 errorPersistent flag.
 */
export const PERSISTENT_CLOUD_BACKEND_ERROR_CODES: ReadonlySet<string> = new Set([
  'FILE_TOO_LARGE',
  'TOO_MANY_ROWS',
  'TOO_MANY_COLUMNS',
  'TOO_FEW_COLUMNS',
  'TIMESTAMP_MISMATCH',
  'INSUFFICIENT_MATCHING_POINTS',
  'TOLERANCE_BOUNDS_EMPTY',
  'MISSING_UTC_COLUMN',
  'MISSING_LOAD_COLUMN',
  'INSUFFICIENT_DATA',
  // Subscription-layer quota code (defense-in-depth; normally handled via the upgrade modal)
  'compute_hours_exhausted',
]);

export function isPersistentCloudErrorCode(code: string | undefined | null): boolean {
  if (!code) return false;
  return PERSISTENT_CLOUD_BACKEND_ERROR_CODES.has(code);
}
